const isMatterportPresentation = (url) => url && url.includes('matterport.com');

export default isMatterportPresentation;
